var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { staticClass: "information", attrs: { role: "article" } },
    [
      _c("h2", { staticClass: "information-title" }, [
        _vm._v("\n    " + _vm._s(_vm.name) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "information-text" }, [
        _c("pre", { staticClass: "pre-custom" }, [
          _vm._v(_vm._s(_vm.description)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }